import React from 'react';

const CustomRadio = ({ label, name, errors = [], checked, ...props }) => {

  return (
    <div className={`flex items-center mb-5 w-full pb-6 pr-6`}>
      {label && (
        <label className="form-label mb-0 mr-2.5" htmlFor={name}>
          {label}:
        </label>
      )}
      <div className={'mr-2'}>
        <span className={'mr-1.5'}>Yes</span>
        <input
          id={name}
          name={name}
          {...props}
          type={'radio'}
          className={''}
          value={1}
          checked={checked}
        />
      </div>
      <div className={'mr-2'}>
        <span className={'mr-1.5'}>No</span>
        <input
          id={name}
          name={name}
          {...props}
          type={'radio'}
          value={0}
          className={''}
          checked={!checked}
        />
      </div>
      {errors && <div className="form-error">{errors}</div>}
    </div>
  );
};

export default CustomRadio;
